import { Route, Routes } from "react-router-dom";
import MainPage from "../../Pages/Submitter/MainPage";
import ApplicationInformation from "../../Containers/ApplicationInformation";
import WorkInformationAndAcademic from "../../Containers/WorkInformationAndAcademic";
import AttachmentsAndDeclaration from "../../Containers/AttachmentsAndDeclaration";
import ScientificContributionSubmittedForTheAward from "../../Containers/ScientificContributionSubmittedForTheAward";


export default function MainRoutesSubmitter() {
  return (
    <Routes>
      <Route path="/ResearchersAward/mainpage" element={<MainPage />} />
      <Route
        path="/ResearchersAward/ApplicationInformation"
        element={<ApplicationInformation />}
      />
      <Route
        path="/ResearchersAward/WorkInformationAndAcademic"
        element={<WorkInformationAndAcademic />}
      />
      <Route
        path="/ResearchersAward/AttachmentsAndDeclarationScreen"
        element={<AttachmentsAndDeclaration />}
      />
      <Route
        path="/ResearchersAward/ScientificContributionSubmittedForTheAwardScreen"
        element={<ScientificContributionSubmittedForTheAward />}
      />

    </Routes>
  );
}
